import {
  CdkDrag,
  CdkDragDrop,
  CdkDragHandle,
  CdkDragPlaceholder,
  CdkDropList,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  model,
  output,
  signal,
  WritableSignal,
} from '@angular/core';
import { form } from '@angular/forms/signals';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { ZoudashUtils } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '../../abstract';
import { DataListColumn } from '../data-table.interface';

export type ColumnRecord = Record<string, boolean>;

export interface ColumnChangedDetection {
  column: ColumnRecord;
  changed: boolean;
}

@Component({
  selector: 'aura-columns-customization',
  templateUrl: './columns-customization.component.html',
  imports: [CdkDrag, CdkDragHandle, CdkDropList, MatCheckbox, MatIcon, MatMenuItem, CdkDragPlaceholder],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColumnsCustomizationAuraComponent<T extends string> extends AbstractSignalFormComponent<
  ColumnRecord,
  ColumnRecord
> {
  readonly currentFilterView = input<string | null>(null);
  columns = model<DataListColumn<T>[]>([]);
  columnChanged = output<ColumnChangedDetection>();

  override model: WritableSignal<ColumnRecord> = signal<ColumnRecord>({});
  override formTree = form(this.model);

  constructor() {
    super();
    effect(() => {
      const cols = this.columns();
      const newModel: ColumnRecord = {};
      cols
        .filter((col) => !col.native)
        .forEach((col) => {
          newModel[col.key] = col.display;
        });
      this.model.set(newModel);
    });
  }

  onCheckboxChange(colKey: string, checked: boolean) {
    this.model.update((m) => ({
      ...m,
      [colKey]: checked,
    }));
  }

  override emitDto(newDto: ColumnRecord): void {
    this.columnChanged.emit({
      column: newDto,
      changed: !ZoudashUtils.isEqual(newDto, this.ogValue),
    });
  }

  protected override buildModelFromDto(dto: ColumnRecord): ColumnRecord {
    return dto || {};
  }

  protected override buildDtoFromModel(model: ColumnRecord): ColumnRecord {
    return model;
  }

  drop(event: CdkDragDrop<DataListColumn<T>>) {
    const columns = this.columns();
    moveItemInArray(columns, event.previousIndex, event.currentIndex);
    this.columns.set([...columns]);
  }
}
